/**
 * Micro Leg Label Updater — Marlot Baus Shopify Theme
 *
 * When a customer selects a surface color on a product with "Microcemento" legs,
 * this script updates the leg option label to show the matching color name.
 * e.g., "Microcemento" → "Microcemento - Arena"
 *
 * Theme structure:
 *   Color radios:  input[name="Color"] inside .attributes-values
 *   Leg group:     .attributes-values-leg
 *   Micro leg:     .attributes__item.attributes__item-color.leg (data-leg-type="PM")
 *   Label text:    <label> inside that .attributes__item
 *
 * Injected via Shopify ScriptTag API. Runs on product pages only.
 */
(function () {
  'use strict';

  if (!window.location.pathname.includes('/products/')) return;

  var MICRO_KEYWORD = 'microcemento';

  function getSelectedColor() {
    var checked = document.querySelector('input[name="Color"]:checked');
    if (checked) return checked.value;

    // Fallback: look for .butSelect in color group
    var sel = document.querySelector('.attributes__item-color.butSelect:not(.leg)');
    if (sel) {
      var label = sel.querySelector('label');
      if (label) return label.textContent.trim();
    }

    return null;
  }

  function getMicroLegItem() {
    // Primary: the micro leg has both .attributes__item-color and .leg classes
    var item = document.querySelector('.attributes__item.attributes__item-color.leg');
    if (item) return item;

    // Fallback: data-leg-type="PM"
    item = document.querySelector('[data-leg-type="PM"]');
    if (item) return item;

    // Fallback: search leg group for "microcemento" text
    var legGroup = document.querySelector('.attributes-values-leg');
    if (legGroup) {
      var labels = legGroup.querySelectorAll('label');
      for (var i = 0; i < labels.length; i++) {
        if (labels[i].textContent.toLowerCase().includes(MICRO_KEYWORD)) {
          return labels[i].closest('.attributes__item') || labels[i];
        }
      }
    }

    return null;
  }

  function updateMicroLabel(colorValue) {
    var microItem = getMicroLegItem();
    if (!microItem) return;

    var newText = 'Microcemento - ' + colorValue;

    // Update the <label> inside the micro item
    var label = microItem.querySelector('label');
    if (label) {
      label.textContent = newText;
    }
  }

  function init() {
    // Check that color radios exist
    var colorRadios = document.querySelectorAll('input[name="Color"]');
    if (!colorRadios.length) return;

    // Check that micro leg option exists
    var microItem = getMicroLegItem();
    if (!microItem) return;

    // Initial update
    var currentColor = getSelectedColor();
    if (currentColor) {
      updateMicroLabel(currentColor);
    }

    // Listen for color changes on all color radios
    colorRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateMicroLabel(this.value);
      });
    });

    // Also listen for click on color items (theme uses onclick for navigation)
    var colorContainer = colorRadios[0].closest('.attributes-values');
    if (colorContainer) {
      colorContainer.addEventListener('click', function (e) {
        var item = e.target.closest('.attributes__item-color:not(.leg)');
        if (item) {
          var radio = item.querySelector('input[name="Color"]');
          if (radio) {
            setTimeout(function () { updateMicroLabel(radio.value); }, 50);
          }
        }
      });
    }

  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 300); });
  } else {
    setTimeout(init, 300);
  }
})();
